import 'vue-svgicon/dist/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { sync } from 'vuex-router-sync'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import moment from 'moment-timezone'
import axios from 'axios';
import VueAxios from 'vue-axios'
import PortalVue from 'portal-vue'
import Toasted from 'vue-toasted'
import VueScrollTo from 'vue-scrollto'
import { loadProgressBar } from 'axios-progress-bar'
import SvgIcon from 'vue-svgicon'
// import VueCookieAcceptDecline from 'vue-cookie-accept-decline'
import VueContentPlaceholders from 'vue-content-placeholders'
import { ReactiveRefs } from 'vue-reactive-refs'
import VueAnalytics from 'vue-analytics'
import './api/bootstrap'
import './icons'
import cookies from './cookies'

import "./scss/app.scss"

Vue.config.productionTip = false

// init third party packages..
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://0e26e52ea5b44350b001c74f1bd50e4f@sentry.io/1516209',
    integrations: [new Integrations.Vue({ Vue, attachProps: true })],
  })
}

Vue.use(VueContentPlaceholders)

Vue.use(ReactiveRefs)

// Vue.component('vue-cookie-accept-decline', VueCookieAcceptDecline)

Object.defineProperty(Vue.prototype, '$moment', { value: moment })

Vue.use(SvgIcon, {
  tagName: 'svgicon'
})

Vue.use(PortalVue)

Vue.use(VueScrollTo, {
  offset: -60
})

Vue.use(Toasted, {
  position: 'bottom-right',
  duration: 5000,
  fullWidth: true,
  containerClass: 'notification-container',
  className: 'notification-element',
  action: {
    text: 'Close',
    class: 'notification-close',
    onClick: (e, toastObject) => toastObject.goAway(0),
  }
})

Vue.prototype.$error = {
  form: () => Vue.toasted.error('There were issues with your submission. Please correct them to continue.'),
  generic: () => Vue.toasted.error('An unknown error occured. Please try again.'),
}

// configure axios & vue-auth
Vue.use(VueAxios, axios)
Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URI

Vue.router = router
if (process.env.NODE_ENV === 'production') {
  Vue.use(VueAnalytics, {
    id: process.env.VUE_APP_UA_ID,
    router,
    ignoreRoutes: ['error.forbidden', 'error.notfound'],
    autoTracking: {
      shouldRouterUpdate(to, from) {
        if (!from.name) return true
        return to.path !== from.path
      }
    },
    disabled: cookies.getCookieStatus() === 'decline',
    debug: {
      sendHitTask: process.env.NODE_ENV === 'production'
    }
  })
}

Vue.use(require('@websanova/vue-auth'), {
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  fetchData: { url: 'profile/show' },
  parseUserData: function (data) {
    return data;
  },
  rolesVar: 'role',
  authRedirect: { name: 'channels.index', query: { login: null } }
})

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response) {
    if (error.response.status === 403) {

      if (error.response.data.message.includes('ban')) {
        Vue.toasted.error(error.response.data.message)
        Vue.auth.logout()
      } else if (error.response.data.message === 'Token Expired') {
        Vue.auth.logout()
      } else {
        Vue.toasted.error(error.response.data.message)
        App.router.replace({
          name: 'error.forbidden'
        })
      }

    } else if (error.response.status === 404) {
      App.router.replace({
        name: 'error.notfound'
      })
    } else if (error.response.status === 429) {
      Vue.toasted.error(error.response.data.message)
    } else {
      if (process.env.NODE_ENV !== 'production') console.log(error.response)
    }
  } else if (error.request) {
    if (process.env.NODE_ENV !== 'production') console.log(error.request)
  } else {
    if (process.env.NODE_ENV !== 'production') console.log('Error', error.message)
  }
  return Promise.reject(error)
});

loadProgressBar({ showSpinner: false })

// setup vue-router & vuex
sync(store, router)
App.router = router
App.store = store

App.store.dispatch('emotes/fetch')
App.store.dispatch('categories/fetch')

// bind components & directives
Vue.component('auth', require('./components/Auth.vue').default)
Vue.component('modal', require('./components/Modal.vue').default)
Vue.component('prompt', require('./components/Prompt.vue').default)
Vue.component('avatar', require('./components/Avatar.vue').default)
Vue.component('captcha', require('./components/Captcha.vue').default)
Vue.component('breadcrumbs', require('./components/Breadcrumbs.vue').default)
Vue.component('username', require('./components/Username.vue').default)

Vue.component('nx-input', require('./components/Input.vue').default)
Vue.component('nx-textarea', require('./components/TextArea.vue').default)
Vue.component('nx-richtextarea', require('./components/RichTextArea.vue').default)
Vue.component('nx-select', require('./components/Select.vue').default)
Vue.component('nx-button', require('./components/Button.vue').default)
Vue.component('nx-file-input', require('./components/FileInput.vue').default)

// start 'er up
new Vue(App).$mount('#app')
